export const findSectionItemNameById = (itemsList, id, fieldName) => {
  return itemsList.find((item) => item[fieldName] === id)?.name || null;
};
